<div class="flex flex-col w-full h-full bg-gray-100 dark:bg-gray-900">
    <div class="flex items-center justify-between px-4 py-4">
        <div class="text-base font-semibold">
            {{ 'Company data' | transloco }}
        </div>

        <button mat-icon-button (click)="closed.emit()">
            <mat-icon [svgIcon]="'mat_outline:close'"></mat-icon>
        </button>
    </div>

    <div class="flex-1 overflow-auto p-4">
        @if (company) {
        <div class="flex flex-col gap-6">
            <div class="manusa-card p-6">
                <div class="flex flex-col gap-6">
                    <div class="flex items-start w-full">
                        <div class="avatar-simple rounded-2xl max-h-32 max-w-32">
                            @if (company?.imageURL) {
                            <img class="max-h-full max-w-full object-contain" [src]="company.imageURL"
                                [alt]="company.name || 'Company image'" />
                            } @else {
                            <div class="icon-container">
                                <img src="images/apps/company-image.png" alt="company image" />
                            </div>
                            }
                        </div>

                        <div class="min-w-0 flex-1 ml-auto text-right">
                            <div class="text-lg font-semibold truncate">
                                {{ company.name || '-' }}
                            </div>
                            <div class="text-secondary text-sm">
                                {{ companyTypeLabelKey | transloco }}
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-col divide-y border-b last:border-0 font-medium">
                        <div class="flex items-center justify-between py-3 gap-4">
                            <div class="text-secondary">{{ 'Company name' | transloco }}</div>
                            <div class="text-right break-words">{{ company.name || '-' }}</div>
                        </div>

                        <div class="flex items-center justify-between py-3 gap-4">
                            <div class="text-secondary">{{ 'VAT number' | transloco }}</div>
                            <div class="text-right break-words">{{ company.nif || '-' }}</div>
                        </div>

                        <div class="flex items-center justify-between py-3 gap-4">
                            <div class="text-secondary">{{ 'Country' | transloco }}</div>
                            <div class="text-right break-words">{{ company.countryName || '-' }}</div>
                        </div>

                        <div class="flex items-center justify-between py-3 gap-4">
                            <div class="text-secondary">{{ 'Postal code' | transloco }}</div>
                            <div class="text-right break-words">{{ company.postalCode || '-' }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="manusa-card p-6">
                <div class="flex items-start justify-between gap-4">
                    <div>
                        <div class="flex items-center gap-1 font-medium">
                            {{ 'Link code' | transloco }}
                            <mat-icon class="icon-size-4 text-gray-700"
                                [matTooltip]="'Share this code to link users to your company' | transloco"
                                [svgIcon]="'mat_solid:info'">
                            </mat-icon>
                        </div>

                        @if (company?.linkCode) {
                        <button class="mt-2 inline-flex items-center gap-2" [cdkCopyToClipboard]="company.linkCode"
                            [matTooltip]="'Copy to clipboard' | transloco">
                            <mat-icon class="icon-size-4" [svgIcon]="'mat_solid:content_copy'"></mat-icon>
                            <span class="text-primary font-bold break-all">{{ company.linkCode }}</span>
                        </button>
                        }
                    </div>

                    <button mat-button class="underline" (click)="generateLinkCode.emit()">
                        {{ 'Generate new code' | transloco }}
                    </button>
                </div>
            </div>

            <div class="text-right w-full sm:w-auto mt-4 sm:mt-0">
                <div (click)="actionSelected.emit('delete')" class="flex items-center justify-start mb-2 gap-1">
                    <mat-icon class="text-red-600 icon-size-5 cursor-pointer" [svgIcon]="'mat_outline:delete'"></mat-icon>
                    <span class="text-red-600 font-medium underline cursor-pointer"> {{'Delete company' | transloco}} </span>
                </div>
            </div>
        </div>
        } @else {
        <div class="flex items-center justify-center h-full text-sm text-secondary">
            {{ 'No data to display' | transloco }}
        </div>
        }
    </div>
</div>
